import { spaceAfterNumber } from '../constants/regex';

// Возвращает строку с пробелами замененными на неразрывные пробелы после чисел
export const convertSpacesToNonBreaking = (str: string) => {
  return str.replace(spaceAfterNumber, '$1\u00A0');
};
